var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"tile":"","size":_vm.size}},[_c('img',{attrs:{"src":_vm.app.logo,"alt":_vm.app.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }